import { createApp } from "vue";
import AhAlert from "../components/AhAlert.vue" // 引入 Alert 组件

// 创建一个全局的消息管理器
const alertManager = {
    install(app) {
        // 动态创建一个 DOM 容器
        const mountPoint = document.createElement("div");
        mountPoint.id = "ah-alert-container";
        document.body.appendChild(mountPoint);

        // 挂载 Alert 组件实例
        const alertApp = createApp(AhAlert);
        const instance = alertApp.mount(mountPoint);

        // 将 $alert 方法挂载到 Vue 原型链上
        app.config.globalProperties.$alert = (options = {}) => {
            return instance.show(options); // 调用组件的 show 方法
        };
    },
};

export default alertManager;